import { IconSvg, IconSvgProps } from "./icon"

export default function TikTok(props: IconSvgProps) {
  return (
    <IconSvg {...props} strokeWidth={0} fill="currentColor">
      <path d="M21.36 9.473a9.25 9.25 0 0 1-5.405-1.728v7.87c-.002 5.51-5.968 8.951-10.74 6.194-4.77-2.756-4.767-9.644.005-12.397a7.158 7.158 0 0 1 4.56-.89v3.958c-2.413-.759-4.743 1.379-4.194 3.848.55 2.47 3.566 3.418 5.43 1.708a3.286 3.286 0 0 0 1.064-2.421V.23h3.875c-.003.327.024.654.082.976A5.38 5.38 0 0 0 18.41 4.74a5.347 5.347 0 0 0 2.95.886Z" />
    </IconSvg>
  )
}
